export default {
  ACCOUNT: 'account',
  WALLET: 'wallet',
};
